const translation = {
  // ── Navigation & Topbar ──
  topbarNotice: 'Proudly serving Brampton & the GTA | 24/7 Service',
  topbarCall: 'Call Us: 416-817-4825',
  topbarGuaranteed: 'Fully Insured & Satisfaction Guaranteed',
  navHome: 'Home',
  navServices: 'Services',
  navAbout: 'Why Us',
  navReviews: 'Reviews',
  navAreas: 'Service Areas',
  navQuote: 'Get a Quote',
  navContact: 'Contact Us',
  navAllServices: 'All Services',
  btnCallNow: 'Call 416-817-4825',
  btnGetQuote: 'Get a Free Quote',

  // ── Hero ──
  heroBadge: 'Family-Owned Cleaning Services You Can Trust',
  heroTitle: 'Spotless Home Cleaning in Brampton & the GTA',
  heroSubhead: 'Reliable teams, professional equipment, and satisfaction guaranteed on every visit — request a free quote today.',
  heroStatRating: '5.0 Rating (500+ Reviews)',
  heroStatInsured: 'Fully Insured & Bonded',
  heroStatGuarantee: '100% Satisfaction Guaranteed',

  // ── Why Us ──
  whyUsLabel: 'Why Choose Us',
  whyUsTitle: 'The clean you deserve, done right.',
  whyUsSubtext: 'We are not just another cleaning company — we are a family-owned local business that treats every home like our own. Here is what sets us apart.',
  whyFamilyTitle: 'Family Owned',
  whyFamilyDesc: 'Local family business built on trust and personal care. We treat every home like our own because our reputation in the community is everything to us.',
  whyReliableTitle: 'Reliable & Trustworthy',
  whyReliableDesc: 'Vetted, insured, and consistent staff. Every cleaner is thoroughly background-checked and trained to deliver consistent quality on every visit.',
  whyPricingTitle: 'Affordable Pricing',
  whyPricingDesc: 'Fair, transparent rates — zero hidden fees. You will always know exactly what you are paying before we start.',
  whySatisfactionTitle: 'Satisfaction Guaranteed',
  whySatisfactionDesc: 'Not happy? We re-clean within 24h for free. That is our promise to every customer — no questions asked.',
  whyFlexibleTitle: 'Flexible Scheduling',
  whyFlexibleDesc: 'Evenings, weekends, same-week bookings. We work around your busy life, not the other way around.',
  whyProTitle: 'Professional Equipment',
  whyProDesc: 'Eco-friendly products & pro-grade HEPA tools. Safe for your family, pets, and the environment.',

  // ── Services ──
  servicesLabel: 'Our Services',
  servicesTitle: 'Cleaning Services We Offer',
  servicesSubtext: 'From routine tidy-ups to full deep cleans — we have got it covered. Every service is backed by our satisfaction guarantee.',
  serviceResidential: 'Residential Cleaning',
  serviceResidentialDesc: 'Regular home cleaning tailored to your schedule — weekly, bi-weekly, or monthly.',
  serviceDeep: 'Deep Cleaning',
  serviceDeepDesc: 'Top-to-bottom detailed clean for baseboards, appliances, grout, and neglected areas.',
  serviceMove: 'Move In / Move Out',
  serviceMoveDesc: 'Leave your old place spotless or start fresh in your new home without stress.',
  serviceOffice: 'Office Cleaning',
  serviceOfficeDesc: 'Keep your workspace fresh, germ-free, and productive with scheduled cleans.',
  serviceAirbnb: 'Airbnb & Vacation Rental',
  serviceAirbnbDesc: 'Fast turnaround cleans between guests, including fresh linens & amenity restocking.',
  servicePostConstruction: 'Post-Construction',
  servicePostConstructionDesc: 'Remove fine dust, heavy debris, and residue after renovations or new builds.',
  serviceBtn: 'Request a Quote',

  // ── Service Detail Pages ──
  serviceDetailBack: 'Back to All Services',
  serviceDetailIncludes: "What's Included",
  serviceDetailPricing: 'Pricing',
  serviceDetailProcess: 'Our Process',
  serviceDetailFaq: 'Frequently Asked Questions',
  serviceDetailBookNow: 'Request a Quote',
  serviceDetailStartingFrom: 'Starting from',
  serviceDetailCAD: 'CAD',
  serviceDetailLearnMore: 'Learn More',
  serviceDetailOverview: 'Overview',
  serviceDetailFreeQuote: 'Free, no-obligation quote',
  serviceDetailQuoteNote: 'Every home and business is different, so we quote each job individually. Share a few details about your space and we will send you a fair, personalized price — usually within 24 hours. No obligation, no pressure.',

  // ── Services Hub Page ──
  servicesHubTitle: 'Complete Cleaning Services Catalog',
  servicesHubSubtext: 'Explore our full range of professional cleaning services. Each service is tailored to your specific needs with transparent pricing and our satisfaction guarantee.',
  servicesHubFilterAll: 'All Services',
  servicesHubFilterResidential: 'Residential',
  servicesHubFilterCommercial: 'Commercial',
  servicesHubFilterSpecialty: 'Specialty',
  servicesHubStartingAt: 'Starting at',
  servicesHubViewDetails: 'View Details',
  servicesHubCtaBanner: 'Not sure which service you need? Get a free consultation and we will help you choose the right package.',
  servicesHubCtaBtn: 'Get Free Consultation',

  // ── Reviews ──
  reviewsLabel: 'Testimonials',
  reviewsTitle: 'Loved by Homeowners Across the GTA',
  reviewsSubtext: 'Real feedback from real customers — see why Brampton and surrounding areas trust AL Cleaning Pro.',
  reviewsBtn: 'Leave a Review',
  reviewsPageTitle: 'Customer Reviews & Testimonials',
  reviewsPageSubtext: '5.0 Average Rating across 500+ verified reviews from homeowners and businesses across the Greater Toronto Area.',
  reviewsFilterAll: 'All Reviews',
  reviewsFilterResidential: 'Residential',
  reviewsFilterDeep: 'Deep Clean',
  reviewsFilterMove: 'Move In/Out',
  reviewsFilterOffice: 'Office',
  reviewsFilterAirbnb: 'Airbnb',
  reviewsFilterConstruction: 'Post-Construction',
  reviewsVerifiedBadge: 'Verified Customer',
  reviewsAverageRating: 'Average Rating',
  reviewsTotalReviews: 'Total Reviews',
  reviewModalTitle: 'Share Your Experience',
  reviewModalName: 'Your Name',
  reviewModalLocation: 'Your City',
  reviewModalService: 'Service Received',
  reviewModalRating: 'Your Rating',
  reviewModalText: 'Your Review',
  reviewModalSubmit: 'Submit Review',
  reviewModalClose: 'Close',
  reviewModalSuccess: 'Thank you for your review! It will appear on the site shortly.',
  reviewPrev: 'Previous review',
  reviewNext: 'Next review',

  // ── About Page ──
  aboutLabel: 'About Us',
  aboutTitle: 'The AL Cleaning Pro Story',
  aboutSubtext: 'From a small family dream to one of the most trusted cleaning services in the GTA — here is our journey.',
  aboutStoryTitle: 'Our Journey',
  aboutStoryP1: 'AL Cleaning Pro was founded in Brampton, Ontario, with a simple mission: provide honest, reliable, and thorough cleaning services that families across the Greater Toronto Area can trust. What started as a small family operation has grown into one of the most respected cleaning companies in the region, serving hundreds of happy homeowners and businesses every month.',
  aboutStoryP2: 'As a family-owned and operated business, we understand the importance of a clean, healthy home. Every member of our team is treated like family, and every home we clean is treated like our own. We do not cut corners — we clean them.',
  aboutStoryP3: 'Today, AL Cleaning Pro proudly serves Brampton, Mississauga, Toronto, Vaughan, Caledon, Milton, Georgetown, and the entire GTA with a growing team of professional, background-checked cleaners and a commitment to excellence that never wavers.',
  aboutValuesTitle: 'Our Core Values',
  aboutValueSafetyTitle: 'Safety First',
  aboutValueSafetyDesc: 'Every team member undergoes thorough background checks and is fully insured and bonded. We use non-toxic, eco-friendly cleaning products that are safe for children, pets, and the environment.',
  aboutValueEcoTitle: 'Eco-Friendly Commitment',
  aboutValueEcoDesc: 'We exclusively use biodegradable, phosphate-free cleaning solutions and HEPA filtration vacuums that capture 99.97% of airborne particles. Better for your home, better for the planet.',
  aboutValueTeamTitle: 'Vetted Professionals',
  aboutValueTeamDesc: 'Our cleaning teams are carefully selected, extensively trained, and continuously evaluated. Every cleaner carries full identification and arrives in company uniform. Consistency and professionalism are our standards.',
  aboutValueGuaranteeTitle: '24-Hour Re-Clean Guarantee',
  aboutValueGuaranteeDesc: 'If you are not completely satisfied with any area we have cleaned, call us within 24 hours and we will return to re-clean it at no additional charge. No questions asked. That is our promise.',
  aboutOwnerTitle: 'Direct Family Oversight',
  aboutOwnerText: 'Unlike large franchises where you never meet the owner, AL Cleaning Pro maintains direct family oversight on every major job. We personally inspect quality and ensure every customer is delighted with the results.',
  aboutCtaText: 'Experience the difference of a family-owned cleaning service. Call us or request your free quote today.',

  // ── Service Areas ──
  areasLabel: 'Coverage',
  areasTitle: 'Service Areas — Proudly Serving the GTA',
  areasSubtext: 'Based in Brampton, we clean homes and offices across the Greater Toronto Area. Our mobile teams reach every corner of the region.',
  areaBrampton: 'Brampton',
  areaBramptonDesc: 'Primary Headquarters',
  areaMississauga: 'Mississauga',
  areaMississaugaDesc: 'Full Coverage',
  areaToronto: 'Toronto',
  areaTorontoDesc: 'Downtown & GTA',
  areaVaughan: 'Vaughan',
  areaVaughanDesc: 'Full Coverage',
  areaCaledon: 'Caledon',
  areaCaledonDesc: 'Full Coverage',
  areaMilton: 'Milton',
  areaMiltonDesc: 'Full Coverage',
  areaGeorgetown: 'Georgetown',
  areaGeorgetownDesc: 'Full Coverage',

  // ── Area City Pages ──
  areaCityBack: 'Back to All Areas',
  areaCityNeighborhoods: 'Neighborhoods We Serve',
  areaCityCoverageMap: 'Service Coverage Map',
  areaCityBookingCta: 'Book a cleaning in',
  areaCityBookNow: 'Get a Quote for',
  areaCityTrustedBy: 'Trusted by hundreds of families in',
  areaCityDescBrampton: 'AL Cleaning Pro is headquartered in Brampton, providing comprehensive home and office cleaning services across all Brampton neighborhoods including Downtown Brampton, Bramalea, Heart Lake, Mount Pleasant, Springdale, and Fletcher\'s Creek.',
  areaCityDescMississauga: 'AL Cleaning Pro provides top-rated residential and office cleaning services across Mississauga, including Square One, Port Credit, Streetsville, Erin Mills, Meadowvale, and Clarkson.',
  areaCityDescToronto: 'AL Cleaning Pro serves Downtown Toronto and the GTA with reliable home cleaning, office cleaning, and specialty cleaning services. Our mobile teams cover Etobicoke, North York, Scarborough, and the downtown core.',
  areaCityDescVaughan: 'AL Cleaning Pro delivers premium home and office cleaning in Vaughan, serving Woodbridge, Maple, Kleinburg, Concord, and Thornhill with reliable, insured, and satisfaction-guaranteed service.',
  areaCityDescCaledon: 'AL Cleaning Pro serves Caledon and surrounding areas including Bolton, Palgrave, Caledon East, and rural estate properties with specialized estate and residential cleaning services.',
  areaCityDescMilton: 'AL Cleaning Pro provides fast, reliable cleaning in Milton — covering the entire town including Milton Heights, Campbellville, and all new residential developments.',
  areaCityDescGeorgetown: 'AL Cleaning Pro offers trusted cleaning services in Georgetown and Halton Hills, covering residential neighborhoods and commercial properties with our professional mobile cleaning teams.',

  // ── Quote Engine ──
  quoteLabel: 'Request a Quote',
  quoteTitle: 'Request Your Free Quote',
  quoteSubtext: 'Share a few details about your cleaning needs and choose how you would like us to reach you. We will review and reply with a fair, no-obligation quote.',
  quoteGuarantee1: 'No obligation — 100% Free',
  quoteGuarantee2: 'Response within 24 hours',
  quoteGuarantee3: 'Flexible same-week scheduling',
  quoteGuarantee4: 'Satisfaction guaranteed',
  quoteStep1: 'Contact Information',
  quoteFullName: 'Full Name',
  quotePhone: 'Phone Number',
  quoteEmail: 'Email Address',
  quoteAddress: 'Address & City',
  quoteStep2: 'Property & Service Details',
  quoteServiceLabel: 'Service Needed',
  quoteBedrooms: 'Bedrooms',
  quoteBathrooms: 'Bathrooms',
  quoteSqft: 'Approximate Square Feet',
  quoteFrequency: 'Frequency',
  quoteOneTime: 'One-Time',
  quoteWeekly: 'Weekly',
  quoteBiWeekly: 'Bi-Weekly',
  quoteMonthly: 'Monthly',
  quoteDate: 'Preferred Cleaning Date',
  quoteNotes: 'Special Notes / Instructions',
  quoteNotesPlaceholder: 'What would you like us to do? Any specific areas to focus on?',
  quoteSubtotal: 'Subtotal',
  quoteDiscount: 'Frequency Discount',
  quoteTax: 'HST (13%)',
  quoteTotal: 'Estimated Total',
  quoteOptionA: 'Request My Free Quote',
  quoteOptionB: 'Book & Pay Online',
  quoteOptionADesc: 'Submit your details and we will get back to you with a personalized quote within 24 hours.',
  quoteOptionBDesc: 'Confirm your booking instantly by paying online with card, Apple Pay, Google Pay, or Interac e-Transfer.',
  quoteSelectService: 'Select a service',
  quoteSelectBedrooms: 'Select bedrooms',
  quoteSelectBathrooms: 'Select bathrooms',
  quoteSelectFrequency: 'Select frequency',
  quoteNameRequired: 'Please enter your full name.',
  quotePhoneRequired: 'Please enter your phone number.',
  quoteEmailRequired: 'Please enter your email address.',
  quoteServiceRequired: 'Please select a service.',
  quoteSuccess: 'Your quote request has been submitted! We will contact you within 24 hours.',
  quoteReferenceId: 'Reference ID',
  quoteClose: 'Close',
  quoteMsgGreeting: "Hello AL Cleaning Pro! I'd like to request a free quote for a cleaning service.",
  quoteEmailSubject: 'New Cleaning Quote Request',
  quoteChannelTitle: 'Choose How to Send Your Request',
  quoteChannelHint: 'Pick the option that is easiest for you — your details will open pre-filled in the app you choose.',
  quoteChannelWhatsApp: 'Send via WhatsApp',
  quoteChannelSMS: 'Send via Text / SMS',
  quoteChannelEmail: 'Send via Email',
  quoteChannelWhatsAppSub: 'Fastest — get a reply on WhatsApp',
  quoteChannelSMSSub: 'Opens your phone messaging app',
  quoteChannelEmailSub: 'Opens your email app, ready to send',

  // ── Booking ──
  bookingLabel: 'Online Booking',
  bookingTitle: 'Pick a Time & Book Instantly',
  bookingSubtext: 'Use the live calendar below to choose your service, pick an available slot, and lock in your cleaning — confirmation lands straight in your inbox.',
  bookingHowTitle: 'How Booking Works',
  bookingStep1Title: 'Choose Your Slot',
  bookingStep1Desc: 'Pick the service and time that suits you best on the live calendar.',
  bookingStep2Title: 'Add Your Details',
  bookingStep2Desc: 'Enter your name, contact info, and address so we arrive prepared.',
  bookingStep3Title: 'Instant Confirmation',
  bookingStep3Desc: 'Your appointment is confirmed by email and synced to our schedule instantly.',
  bookingNoteTitle: 'Never Double-Booked',
  bookingNoteDesc: 'Our calendar updates in real time — once you book a slot, it is blocked for everyone else.',
  bookingEmailLabel: 'Confirmation & Notices',
  bookingEmailValue: 'Sent to your email instantly after booking.',
  bookingLoading: 'Loading booking calendar…',

  // ── Contact Page ──
  contactPageTitle: 'Get in Touch',
  contactPageSubtext: 'Have questions or ready to book? Reach out — we are available 24/7 to help with your cleaning needs.',
  contactFormTitle: 'Send Us a Message',
  contactFormName: 'Your Name',
  contactFormEmail: 'Email Address',
  contactFormPhone: 'Phone Number',
  contactFormSubject: 'Subject',
  contactFormMessage: 'Your Message',
  contactFormSubmit: 'Send Message',
  contactFormSuccessTitle: 'Message Sent!',
  contactFormSuccessText: 'Thank you for reaching out. We will get back to you within 24 hours.',
  contactFormError: 'Something went wrong. Please try again or call us directly.',
  contactInfoTitle: 'Contact Information',
  contactPhoneLabel: 'Phone',
  contactEmailLabel: 'Email',
  contactAddressLabel: 'Address',
  contactHoursLabel: 'Business Hours',
  contactHoursValue: 'Open 24 Hours / 7 Days a Week',
  contactMapTitle: 'Our Location',

  // ── Checkout Modal ──
  checkoutTitle: 'Book & Pay Online',
  checkoutSubtext: 'Secure your booking instantly. Choose your preferred payment method below.',
  checkoutDeposit: 'Pay Deposit ($50 CAD)',
  checkoutFullAmount: 'Pay Full Amount',
  checkoutStripeTab: 'Credit Card / Apple Pay',
  checkoutInteracTab: 'Interac e-Transfer',
  checkoutStripeDesc: 'Pay securely with Visa, Mastercard, AMEX, Apple Pay, or Google Pay.',
  checkoutInteracDesc: 'Send your payment via Interac e-Transfer using the details below.',
  checkoutInteracEmail: 'Send e-Transfer to',
  checkoutInteracMemo: 'Memo / Reference',
  checkoutInteracNote: 'Please include your booking reference ID in the e-Transfer memo. Your appointment will be confirmed once we receive the payment.',
  checkoutPayNow: 'Pay Now',
  checkoutProcessing: 'Processing...',
  checkoutAmount: 'Amount',
  checkoutBookingRef: 'Booking Reference',
  checkoutCancel: 'Cancel',

  // ── Home Page Sections ──
  homeServicesPreviewTitle: 'Our Cleaning Services',
  homeServicesPreviewLink: 'View All Services',
  homeReviewsPreviewTitle: 'What Our Customers Say',
  homeReviewsPreviewLink: 'Read All Reviews',
  homeAreasPreviewTitle: 'Serving the GTA',
  homeAreasPreviewLink: 'See All Areas',
  homeCtaTitle: 'Ready for a spotless space?',
  homeCtaSubtext: 'Get your free, no-obligation quote in under 60 seconds. Same-week bookings available.',

  // ── Our Work Gallery ──
  ourWorkLabel: 'Our Recent Work',
  ourWorkTitle: 'See the AL Cleaning Pro Difference',
  ourWorkSubtext: 'Browse through some of our recent cleaning projects across the GTA. Real results, real transformations — from cluttered to immaculate.',
  ourWorkViewMore: 'View Full Gallery',
  ourWorkBefore: 'Before',
  ourWorkAfter: 'After',
  ourWorkCategoryResidential: 'Residential Clean',
  ourWorkCategoryDeep: 'Deep Clean',
  ourWorkCategoryMove: 'Move Out Clean',
  ourWorkCategoryOffice: 'Office Clean',
  ourWorkCategoryAirbnb: 'Airbnb Turnover',
  ourWorkCategoryConstruction: 'Post-Construction',

  // ── Home Page Section: Our Work ──
  homeOurWorkTitle: 'Our Recent Work',
  homeOurWorkSubtext: 'Real results from real homes and businesses across the GTA. This is what a professional clean looks like.',

  // ── Footer ──
  footerCtaTitle: 'Ready for a spotless space?',
  footerCtaSubtext: 'Call or email today for a free, no-obligation quote. Flexible scheduling — same-week bookings available.',
  footerCall: 'Call',
  footerEmail: 'Email Us',
  footerQuickLinks: 'Quick Links',
  footerOurServices: 'Our Services',
  footerContactUs: 'Contact Us',
  footerBrandDesc: 'Family-owned cleaning services in Brampton and the GTA. Satisfaction guaranteed on every visit.',
  footerFollowUs: 'Follow Us',
  footerLegal: '© 2026 AL Cleaning Pro. All rights reserved.',
  footerInsured: 'Fully Insured & Bonded Family Business',

  // ── WhatsApp / SMS ──
  whatsappChat: 'Chat on WhatsApp',
  topbarWhatsApp: 'WhatsApp',
  smsBtn: 'Text Us',
  smsBody: "Hi AL Cleaning Pro! I'd like to request a free quote for a cleaning service.",
  contactQuickTitle: 'Fastest Ways to Reach Us',

  // ── Common ──
  langEnglish: 'English',
  langFrench: 'Français',
  switchLang: 'Switch to French',
  loading: 'Loading...',
  pageNotFound: 'Page Not Found',
  pageNotFoundDesc: 'The page you are looking for does not exist.',
  backToHome: 'Back to Home',
};

export default translation;